const _excluded = ["intent", "icon", "footer", "withAction", "className", "children", "weight", "variant", "hideIcon", "withBorder", "classes"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import { BulbLiner24, DangerLiner24, CloseCircleLiner24 } from "../../icons";
import { Typography } from "../Typography";
import styles from "./Callout.module.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const iconsMap = {
  info: /*#__PURE__*/_jsx(BulbLiner24, {
    width: 18,
    height: 18
  }),
  warning: /*#__PURE__*/_jsx(DangerLiner24, {
    width: 18,
    height: 18
  }),
  error: /*#__PURE__*/_jsx(CloseCircleLiner24, {
    width: 18,
    height: 18
  })
};
export function Callout(props) {
  const {
      intent = 'info',
      icon,
      footer,
      withAction,
      className,
      children,
      weight,
      variant,
      hideIcon,
      withBorder,
      classes
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/_jsxs("div", {
    className: cn(styles.root, styles[intent], {
      [styles.border]: withBorder
    }, classes === null || classes === void 0 ? void 0 : classes.wrapper, className),
    children: [/*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
      className: cn(styles.main, classes === null || classes === void 0 ? void 0 : classes.main)
    }, rest), {}, {
      children: [!hideIcon && /*#__PURE__*/_jsx("div", {
        className: styles.icon,
        children: icon || iconsMap[intent]
      }), /*#__PURE__*/_jsx(Typography, {
        className: styles.content,
        weight: weight,
        variant: variant,
        children: children
      }), withAction]
    })), footer && /*#__PURE__*/_jsx("div", {
      className: cn(styles.footer, classes === null || classes === void 0 ? void 0 : classes.footer),
      children: footer
    })]
  });
}